<mat-card class="cardWithShadow overflow-hidden mb-0! dark:bg-gray-800/80 dark:border dark:border-gray-700/50">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="dark:text-emerald-50">Monthly Earnings</mat-card-title>
    <div class="m-l-auto">
      <button class="bg-secondary dark:bg-emerald-700 rounded-full flex items-center justify-center icon-48">
        <mat-icon class="text-white flex">currency_dollar</mat-icon>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <h4 class="text-lg font-semibold dark:text-emerald-50">$6,820</h4>
    <div class="flex items-center mt-2.5">
      <button class="bg-light-error dark:bg-red-900/50 rounded-full flex items-center justify-center text-error dark:text-red-400 icon-22">
        <mat-icon class="icon-16 flex">arrow_downward</mat-icon>
      </button>
      <div class="text-sm font-semibold ml-3 dark:text-emerald-50">+9%</div>
      <div class="text-sm font-normal ml-1 text-muted dark:text-gray-300">last year</div>
    </div>
  </mat-card-content>

  <!-- ---------------------------- -->
  <!-- charts here -->
  <!-- ---------------------------- -->
  <apx-chart [series]="monthlyChart.series" [dataLabels]="monthlyChart.dataLabels" [chart]="monthlyChart.chart"
    [legend]="monthlyChart.legend" [colors]="monthlyChart.colors" [stroke]="monthlyChart.stroke"
    [tooltip]="monthlyChart.tooltip" [plotOptions]="monthlyChart.plotOptions" [fill]="monthlyChart.fill"
    [responsive]="monthlyChart.responsive"></apx-chart>
</mat-card>